<template lang="pug">
  div.wrap-module-about.f.fh.py40
    div.about-content
      //- div.mb30
        h2.block.text-center.mb12 APP
        p You can download 
          | #[a(href="https://apps.apple.com/us/app/hack-in-%E3%83%8F%E3%83%83%E3%82%AF%E3%82%A4%E3%83%B3/id1592283554" target="brank") here].
        p Beta version is 
          | #[a(href="https://testflight.apple.com/join/BoU6SQEo" target="brank") here]. through TestFlight.
          | For now, there is only iOS APP.
      div.mb30
        h2.block.text-center.mb12 How to Start
        //- h3.mb4 Note
        p Hack in is invitation only for now. The person with an invitation code can join this community.
        p But you can apply preregistor for public version #[a(href="https://docs.google.com/forms/d/1nXVGb6VaDwT2dgAzLxBHCgJSXOhZpg_gWO02MiRbHRk/edit" target="brank") here].
        p If you are my acquaintance, please contact #[a(href="mailto:hello@hackin.wiki") me]. I'll send an invitation for Beta version to you.
      div.mb30
        h2.block.text-center.mb12 About
        div.wrap-video
          iframe(frameborder="0" allow="autoplay; fullscreen" allowfullscreen
            src="https://player.vimeo.com/video/297550093?h=c13e6c72ba&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479")
        h3.mb12 What is Hack in?
        v-img(src="/img/intro/user.png")
        p Hack in is the new experimental social network where a user can post instead of another user as his/her agent.
        v-img(src="/img/intro/post.png")
        //- v-img(src="/img/intro/1.jpg")
        //- v-img(src="/img/intro/2.jpg")
        //- v-img(src="/img/intro/3.jpg")
        p And his/her followers can evaluate the post by “alike” or “unlike” instead of “like” or “bad”.
        v-img(src="/img/intro/alike.png")
        //- v-img(src="/img/intro/4.jpg")
        //- v-img(src="/img/intro/5.jpg")
        p When a user creates a new friend’s post, he/she tries to create what his/her friends will likely say and get “alike” by followers.
        v-img(src="/img/intro/unlike.png")
        p The purpose of this app is to think about who you are through posts created by your friends as your agent.
        p For example, it’s possible that your post created by your friend is more evaluated by your followers compared with your original post you created by yourself. In this case, you may find a new aspect you didn’t know.
      div.mb30
        h2.block.text-center.mb12 Contact
        p Please contact me about Hack in #[a(href="mailto:hello@hackin.wiki") here].
      div.mb30
        h2.block.text-center.mb12 Developer
        p Hack in is developed by #[a(href="http://kooh.me" target="brank") kooh]
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-about {
  padding-top: $header_height;
  .about-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-video {
      position: relative;
      padding-bottom: 56.25%;
      padding-top: 30px;
      height: 0;
      overflow: hidden;
      iframe {
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<script>

export default {
  components: {
  },
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  data () {
    return {
      
    }
  },
  methods: {
    onLoggedIn () {
      
    }
  }
}
</script>
